var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.393c-2.576.722-5.466 1.12-8.696 1.12h-.608c-18.435 0-25.826-12.98-26.609-25.117a20.683 20.683 0 01-.087-1.64c.022-.27.033-.542.044-.82.01-.265.022-.536.043-.818.391-6.072 2.437-12.355 6.691-17.118H68a5 5 0 015 5v39.393z",
    fill: "#9B8CF9",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_allContracts)",
    filter: "url(#filter0_dAllContract)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.547 38.718h-5.203V17.695h9.716l-4.513 21.023z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.355 38H57V18h10l-4.645 20z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.874 3.998L32 9.8l2.244 7.98 20.874-5.803-2.244-7.979z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.773 4.15L32.248 9.855l2.172 7.724 20.525-5.706-2.172-7.723z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.754 9.578l-5.164 1.435.11.392 5.164-1.435-.11-.392z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.195 11.144l-5.164 1.435.11.392 5.164-1.435-.11-.392zm2.912-1.654l-8.298 2.306.11.392 8.298-2.307-.11-.392zm-10.193 4.03a.948.948 0 10-.514-1.827.948.948 0 10.514 1.827z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.584 5.778l-20.408 7.554 3.881 10.366 20.408-7.554-3.881-10.366z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43 6.07l-19.973 7.393 3.885 10.376 19.973-7.393L57.43 6.071z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.898 12.23l-5.025 1.86.143.38 5.025-1.86-.143-.38z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.468 13.753l-5.025 1.86.143.381 5.025-1.86-.143-.38z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344 11.867l-8.1 2.998.143.383 8.1-2.999-.143-.382zm-9.932 4.861a.947.947 0 00.562-1.22.956.956 0 00-1.228-.559.947.947 0 00-.561 1.22.956.956 0 001.227.559z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.615 12.122l-1.49 8.317 21.385 3.787L66 15.909l-21.385-3.787z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7 16.035l-20.98-3.716-4.02 22.427 20.982 3.716L65.7 16.035z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.925 16.098l-.072.4 5.28.935.071-.4-5.279-.935z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.638 17.7l-.072.4 5.28.935.071-.4-5.279-.935z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.783 16.899l-.072.4 8.483 1.503.072-.4-8.483-1.503zm-1.357-.034a.95.95 0 00-.773-1.1.95.95 0 10-.335 1.868.954.954 0 001.108-.768z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.477 17.448l-3.512-2.445h-4.863v24.102h30.393V17.448H40.477z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.267 17.434L36.8 15H32v24h30V17.434H40.267z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.322 33.584a.342.342 0 01-.346.343H39.69a.347.347 0 01-.345-.343V23.31a.342.342 0 01.345-.343h15.285a.346.346 0 01.346.343",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.289 23.442H40.388a.435.435 0 00-.437.434v9.178c0 .24.196.434.437.434h13.9a.435.435 0 00.437-.434v-9.178a.435.435 0 00-.436-.434z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.091 23.686H40.57a.436.436 0 00-.437.434v8.651c0 .24.195.435.437.435h13.52a.436.436 0 00.437-.435v-8.65a.436.436 0 00-.437-.435z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B9AFFB",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    d: "M41.906 25.295h9.569m-9.569 2.055h6.811m.912 3.561h1.845"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62.202,
    y1: 38.718,
    x2: 62.202,
    y2: 17.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9455.37,
    y1: 1731.6,
    x2: 9254.56,
    y2: -631.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13936.7,
    y1: 6212.05,
    x2: 14265.7,
    y2: 2896.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7320.3,
    y1: 10532.9,
    x2: 7799.37,
    y2: 5167.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 9454.01,
    y1: 16768.5,
    x2: 9454.01,
    y2: 4928.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 4631.76,
    y1: 5856.78,
    x2: 4631.76,
    y2: 3799.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_allContracts"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(32 4)",
    d: "M0 0h36v34.105H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dAllContract",
    x: 31,
    y: 4,
    width: 38,
    height: 36.105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.9914503018760346203b93701447fe88.svg";
export { ForwardRef as ReactComponent };